
import React, { Fragment, useEffect, useState, Suspense} from "react";
import { useParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Link } from "react-router-dom";
import L from 'leaflet';

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const ThreeDViewer = React.lazy(() => import('../../components/3dViewer'));
const ImgViewer = React.lazy(() => import('../../components/ImgViewer'));


function ItemPage() {
  const [object, setObject] = useState(null); 
  const [totalItems, setTotalItems] = useState(null); 
  const { itemid } = useParams(); 


  const defaultIcon = L.icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIconRetina,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  const fetchItem = async () => {
    try {
      const response = await fetch(`/api/item/${itemid}`);
      const jsonData = await response.json();
      setObject(jsonData[0]); 
    } catch (err) {
      console.error(err.message);
    }
  };

  
  const fetchTotalItems = async () => {
    try {
      const response = await fetch(`/api/archive`);
      const jsonData = await response.json();
      setTotalItems(jsonData.length);
      
    } catch (err) {
      console.error(err.message);
    }
  };


  useEffect(() => {
    fetchItem();
  }, [itemid]
);

useEffect(() => {
  fetchTotalItems();
}, []); 

  if (!object) {
    return <div className="loadingmsg">
    <div className="spinner"></div>
    Loading...
  </div>; 
  }

  const currentId = parseInt(itemid, 10);
  const nextId = currentId < totalItems ? currentId + 1 : 1; // Eğer son öğedeysek başa dön
  const prevId = currentId > 1 ? currentId - 1 : totalItems; // Eğer ilk öğedeysek sona dön

  
  const hasCoordinates = object.lat && object.lng;
  const media = object.med_name;
  
  const isVideo = object.med_name && Array.isArray(object.med_name) && object.med_name[0].toLowerCase() === 'video';
  const is3DModel = object.med_name && Array.isArray(object.med_name) && object.med_name[0].toLowerCase() === '3d';
  const mediaUrls = object.media.split(', ');

  
  return (
  <Fragment>

<div key={object.obj_id} className="itempg_content">  
  <div className="itempg_media">
  
    <div className="itemchange">
          <Link to={`/item/${prevId}`}>
          <button className="prev" data-short-text="Prev Item">
            Previous Item
          </button>
          </Link>
          <Link to={`/item/${nextId}`}>
          <button className="next" data-short-text="Next Item">
            Next Item
          </button>
          </Link>
    </div>
  
      {isVideo ? (
      <video className="detail_video" controls>
      <source
        src={`/api/uploads/${object.media}`}
        type="video/mp4" 
      />
      </video>
        ) : is3DModel ? (
        <Suspense fallback={<div>Media Loading...</div>}>
        <ThreeDViewer objPath={`/api/uploads/${object.media}`} />
        </Suspense>
        ) : (
      <div>
      {mediaUrls.map((mediaUrl, index) => (
        <Suspense fallback={<div>Media Loading...</div>}>
      <ImgViewer
            src={mediaUrls.join(',')}
            alt={object.media}
          />
          </Suspense>
        ))}
      </div>
        )}
  </div>

  <div className="itempg_data">
    <div className="itempg_data_table">
    
      <h1>{object.title}</h1>
    
        <div className="itempg_data_cont-col">
        <h3>Identifiers</h3>  
          <div className="itempg_data_row">
              <h5 className="itempg_title">Reference ID:</h5>
            <div className="itempg_value">
              <span className="data-value">{object.ref_id}</span>
              <hr />
            </div>
          </div>

          <div className="itempg_data_row">
              <h5 className="itempg_title">Project:</h5>
            <div className="itempg_value">
                  <Link to={`../project/${object.prj_id}`}>
                    <span className="data-value">{object.prj_name}</span>
                  </Link>
                  <hr />
            </div>
          </div>
          
          <div className="itempg_data_row">      
              {object.description ? (
                <>
                <h5 className="itempg_title">Description:</h5>
            <div className="itempg_value_desc">
                <span className="data-value">{object.description}</span>
                <hr />
              </div>
                </>
              ) : (
            <div className="na">No Data</div>
              )}  
          </div>
     
          <div className="itempg_data_row">
              <h5 className="itempg_title">Media Type:</h5>
            <div className="itempg_value">
              {object.med_name.map((med_name, index) => (
                  <span key={index}>
                    <Link to={`../media/${object.med_id[index]}`}>
                      <span className="data-value">{med_name}</span>
                    </Link>
                    {index < object.med_name.length - 1 && ' '}
                  </span>
                ))}
                  <hr />
            </div>
          </div>
          
          <div className="itempg_data_row">
              <h5 className="itempg_title">Object Type:</h5>
            <div className="itempg_value">
                <span className="data-value">{object.object_type}</span>

            </div>
          </div>
        </div>

  <hr />

        <div className="itempg_data_cont-col">

        <h3>Context</h3>  

          <div className="itempg_data_row">
              {object.col_name[0] !== null ? (
              <>
              <h5 className="itempg_title">Collection:</h5>
            <div className="itempg_value">
                {object.col_name.map((col, index) => (
                  <span key={index}>
                    <Link to={`../collection/${object.col_id[index]}`}>
                      <span className="data-value">{col}</span>
                    </Link>
                    {index < object.col_name.length - 1 && ' '}
                  </span>
                ))}
                  <hr />
            </div>
              </>
                ) : (
                <div className="na">No Data</div>
                )}
          </div>

          <div className="itempg_data_row">    
              {object.cat_names && object.cat_names[0] !== null ?(
                    <>
            <h5 className="itempg_title">Category:</h5>
              <div className="itempg_value">
                    {object.cat_names.map((name, index) => (
                      <span key={index}>
                        <Link to={`../category/${object.cat_id}`}>
                          <span className="data-value">{name}</span>
                        </Link>
                        {index < object.cat_names.length - 1 && ' '}
                      </span>
                    ))}
                    <hr />
              </div>
                  </>
                ) : (
                  <div className="na">No Data</div>
              )}
          </div>

          <div className="itempg_data_row">
              {object.subcat_id && object.subcat_name[0] !== null ? (
                    <>
              <h5 className="itempg_title">Subcategory:</h5>
            <div className="itempg_value">
                {object.subcat_name.map((subcat, index) => (
                  <span key={index}>
                    <Link to={`../subcategory/${object.subcat_id[index]}`}>
                      <span className="data-value">{subcat}</span>
                    </Link>
                    {index < object.subcat_name.length - 1 && ' '} {}
                  </span>
                ))}
                <hr />
            </div>
                </>  ) : (
                    <div className="na">No Data</div>
                  )}
          </div>
          
          <div className="itempg_data_row">
          {object.keywords?.length > 0  ? (
              <>
              <h5 className="itempg_title">Keyword:</h5>
            <div className="itempg_value">
                {object.keywords.map((keyword, index) => (
                  <span key={index}>
                    <Link to={`../keyword/${object.key_id[index]}`}>
                      <span className="data-value">{keyword}</span>
                    </Link>
                    {index < object.keywords.length - 1 && <span className="separator"> - </span>} {}
                  </span>
                ))}
                <hr />
            </div>
            </>
            ) : (
              <div className="na">No Data</div>
              )}
          </div>

          <div className="itempg_data_row">
                  {object.notes ? (
                    <>
                <h5 className="itempg_title">Notes:</h5>
            <div className="itempg_value">
                    <span className="data-value">{object.notes}</span>
                    <hr />
            </div> 
                    </>   
                    ) : (
                      <div className="na">No Data</div>
                    )}
          </div>   

          <div className="itempg_data_row">
                {object.rel_obj_id && object.rel_obj_id[0] !== null ? (
                <>
              <h5 className="itempg_title">Related Object:</h5>
            <div className="itempg_value">
                {object.rel_obj.map((rel_obj, index) => (
                  <span key={index}>
                    <Link to={`../item/${object.rel_obj_id[index]}`}>
                      <span className="data-value">{rel_obj}</span>
                    </Link>
                    {index < object.rel_obj.length - 1 && ' '} {}
                  </span>
                ))}
                <hr />
            </div>
              </> 
              ) : (
              <div className="na">No Data</div>
              )}
          </div>
          
          <div className="itempg_data_row">
              {object.ex_link ? (
                <>
                <h5 className="itempg_title">External Link:</h5>
            <div className="itempg_value">  
                <span className="data-value">
                  <a href={object.ex_link} target="_blank" rel="noopener noreferrer">
                    {object.ex_link}
                  </a>
                </span>
                <hr />
            </div>
                </>
              ) : (
            <div className="na">No Data</div>
            )}
          </div>
        </div>


  <hr />
        
        <div className="itempg_data_cont-col">
        
          <h3>Rights</h3>

          <div className="itempg_data_row">
            {object.restrict_note && object.restrict_note[0] !== null ? (
              <>
              <h5 className="itempg_title">Restriction Note:</h5>
            <div className="itempg_value">
                <span className="data-value">{object.restrict_note}</span>
            </div>
            </>
            ) : (
            <div className="na">No Data</div>
            )}
          </div>   
 

        <div className="itempg_data_row">
            {object.disclaimer && object.disclaimer[0] !== null ? (
              <>
              <h5 className="itempg_title">Disclaimer:</h5>
            <div className="itempg_value">
                <span className="data-value">{object.disclaimer}</span>
                <hr />
            </div>
            </>
            ) : (
            <div className="na">No Data</div>
            )}
        </div>   

        <div className="itempg_data_row">
              <h5 className="itempg_title">Licence:</h5>
            <div className="itempg_value">
                    <a href={object.lic_url} target="_blank" rel="noopener noreferrer">
                      <span className="data-value">{object.lic_name}</span>
                    </a>
            </div>
        </div> 
      </div> 

  <hr />

        <div className="itempg_data_cont-col">
          <h3>People</h3>

          <div className="itempg_data_row">
          {object.creator_id?.length > 0 ? (
            <> 
              <h5 className="itempg_title">Creator:</h5>
            <div className="itempg_value">  
                  {object.creator_nick.map((person, index) => (
                    <span key={index}>
                      <Link to={`../people/${object.creator_id[index]}`}>
                        <span className="data-value">{person}</span>
                      </Link>
                      {index < object.creator_nick.length - 1 && 
                      <span className="separator"> - </span>}
                    </span>
                  ))}
                  <hr />
            </div>
            </>
            ) : (
            <div className="na">No Data</div>
            )}
          </div>

          <div className="itempg_data_row">
              <h5 className="itempg_title">Recorder:</h5>
            <div className="itempg_value">  
                  {object.recorder_names.map((person, index) => (
                    <span key={index}>
                      <Link to={`../people/${object.recorder_id[index]}`}>
                        <span className="data-value">{person}</span>
                      </Link>
                      {index < object.recorder_names.length - 1 && ' '}
                    </span>
                  ))}
            </div>
          </div>
        </div>

      <hr />
        
        <div className="itempg_data_cont-col">
        
          <h3>Time</h3>
  
          <div className="itempg_data_row">
              <h5 className="itempg_title">Record Date:</h5>
            <div className="itempg_value">  
                    <span className="data-value">
                      {object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                    </span>
                    <hr />
            </div>
          </div>
          
          <div className="itempg_data_row">
          {object.record_time && object.record_time[0] !== null ? (
            <>
              <h5 className="itempg_title">Record Time:</h5>
            <div className="itempg_value"> 
                    <span className="data-value">
                      {object.record_time
                        ? new Date(`1970-01-01T${object.record_time}Z`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                        : 'No time available'}
                    </span>
                    <hr />
            </div>
            </> 
          ) : (
            <div className="na">No Data</div>
          )}
          </div>
          
          <div className="itempg_data_row">
          {object.create_date && object.create_date[0] !== null ? (
            <>
              <h5 className="itempg_title">Creation Date:</h5>
            <div className="itempg_value">
                    <span className="data-value">
                      {object.create_date ? new Date(object.create_date).toLocaleDateString() : 'Creation date unknown'}
                    </span>
                    <hr />
            </div>
            </> 
          ) : (
            <div className="na">No Data</div>
          )}
          </div>

          
          <div className="itempg_data_row">
              {object.disappear_date && object.disappear_date[0] !== null ? (
              <>
              <h5 className="itempg_title">Disappearing Date:</h5>
            <div className="itempg_value">
                    <span className="data-value">
                      {object.disappear_date ? new Date(object.disappear_date).toLocaleDateString() : 'No date available'}
                    </span>
            </div>
              </>
            ) : (
              <div className="na">No Data</div>
            )}
          </div>
          
          <div className="itempg_data_row">
              <h5 className="itempg_title">Upload Date:</h5>
            <div className="itempg_value">
                    <span className="data-value">
                      {object.upload_date ? new Date(object.upload_date).toLocaleDateString() : 'No date available'}
                    </span>
            </div>
          </div> 
        </div>

        <hr />
  
        {object.cont_id && object.cont_id[0] !== null ? (
        <>
        <div className="itempg_data_cont-col">  
                  
        <h3>Space</h3>

          <div className="itempg_data_row">
          {object.cont_id && object.cont_id[0] !== null ? (
              <>
              <h5 className="itempg_title">Country:</h5>
            <div className="itempg_value">
                    <Link to={`../place/country/${object.cont_id}`}>
                      <span className="data-value">{object.cont_name}</span>
                    </Link>
                    <hr />
            </div>   
            </>
            ) : (
            <div className="na">No Data</div>
            )}
          </div>  

          <div className="itempg_data_row">
          {object.city_id && object.city_id[0] !== null ? (
            <>
              <h5 className="itempg_title">City:</h5>
            <div className="itempg_value">
                    <Link to={`../place/city/${object.city_id}`}>
                        <span className="data-value">{object.city_name}</span>
                    </Link>
                    <hr />
            </div>   
            </>
            ) : (
            <div className="na">No Data</div>
            )}
          </div> 

          <div className="itempg_data_row">
              {object.town_name && object.town_name[0] !== null ? (
                <>
              <h5 className="itempg_title">Town:</h5>
            <div className="itempg_value">
                    <Link to={`../place/town/${object.town_id}`}>
                        <span className="data-value">{object.town_name}</span>
                    </Link>   
                    <hr />
            </div>  
              </>
              ) : (
              <div className="na">No Data</div>
              )}
          </div>  

          <div className="itempg_data_row">
              {object.place && object.place[0] !== null ? (
              <>
              <h5 className="itempg_title">Place:</h5>
            <div className="itempg_value">
              <span className="data-value">{object.place}</span>
              <hr />
            </div>
              </>
              ) : (
              <div className="na">No Data</div>
              )}
          </div>  

          <div className="itempg_data_row">
              {object.lat && object.lat[0] !== null ? (
              <>
              <h5 className="itempg_title">Latitude:</h5>
            <div className="itempg_value">
              <span className="data-value">{object.lat}</span>
              <hr />
            </div>
                </>
                ) : (
                <div className="na">No Data</div>
                )}
          </div>

          <div className="itempg_data_row">
              {object.lng && object.lng[0] !== null ? (
              <>
              <h5 className="itempg_title">Longitude:</h5>
            <div className="itempg_value">
                  <span className="data-value">{object.lng}</span>
                  
            </div>
                </>
                ) : (
                <div className="na">No Data</div>
                )}
          </div>
        </div>

        <br />

        <div className="itempg_data_cont_map">
                {hasCoordinates ? (
            <MapContainer center={[object.lat, object.lng]} zoom={11} style={{ height: "50vh", width: "100%" }}>
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker key={object.obj_id} position={[object.lat, object.lng]} icon={defaultIcon}>
                      <Popup>{object.title}</Popup>
                    </Marker>
                  </MapContainer>
                ) : (
                  <div>No map available</div> 
                  )}
          </div>            
          
        </>
          ) : (
            <div className="na">No Data</div>
          )}
           
      </div> 
  
    </div>  
  </div> 

    </Fragment>
  );
  
}

export default ItemPage;
